import React from 'react';

const Row = ({ row }) => {
    return (
        <tr>
            <td>{row.source}</td>
            <td>{row.affid}</td>
            <td>{row.country}</td>
            <td>{row.impressions}</td>
            <td>{row.clicks}</td>
            <td>{row.revenue}</td>
            <td>{row.ctr}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderCtr/components/Table/components/Row/index.js